import { useQuery } from '@apollo/client';

import { BankAccountStatus } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { MultiWalletLimitsDocument } from './graphql/multiWalletLimits.gql';
import locales from './locales';

export const useCanCreateAdditionalWallet = () => {
  const { companyProfileId } = useCompanyContext();
  const { data, loading } = useQuery(MultiWalletLimitsDocument, {
    skip: !companyProfileId,
    variables: { companyProfileId: companyProfileId as string },
  });

  if (loading || !data) {
    return {
      description: undefined,
      value: false,
    };
  }

  const {
    bankAccounts,
    currentPlan: { limits },
  } = data.viewer.company;

  const activeBankAccounts = bankAccounts.filter(
    ({ status }) => status !== BankAccountStatus.Closed,
  );

  const canCreateAdditionalWallet =
    limits.activeBankAccounts.value - activeBankAccounts.length > 0;

  return {
    description: canCreateAdditionalWallet ? null : locales.limitReached,
    value: canCreateAdditionalWallet,
  };
};
